import { render, staticRenderFns } from "./MaterialVariantHistory.vue?vue&type=template&id=d9b8ec80&scoped=true"
import script from "./MaterialVariantHistory.vue?vue&type=script&lang=js"
export * from "./MaterialVariantHistory.vue?vue&type=script&lang=js"
import style0 from "./MaterialVariantHistory.vue?vue&type=style&index=0&id=d9b8ec80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b8ec80",
  null
  
)

export default component.exports